import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // IMPORT BrowserRouter HERE
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode>
<BrowserRouter> {/* WRAP YOUR <App /> COMPONENT HERE */}
<App />
</BrowserRouter>
</React.StrictMode>
);
reportWebVitals();